import * as React from "react";
import { SVGProps, memo } from "react";

const SpotifyAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 90 93"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.193 32.306A23.044 23.044 0 0 0 41.143 18c0-2.362-.354-4.64-1.011-6.787a41.294 41.294 0 0 1 8.725-.927v.002C71.58 10.288 90 28.708 90 51.428c0 22.724-18.419 41.143-41.143 41.143-22.722 0-41.143-18.419-41.143-41.142 0-4.142.612-8.14 1.75-11.911A23.08 23.08 0 0 0 18 41.143a23.32 23.32 0 0 0 3.418-.25 3.85 3.85 0 0 0 3.977 1.105c12.66-3.842 34.538-3.118 47.798 4.758h.002a3.845 3.845 0 0 0 5.271-1.346 3.844 3.844 0 0 0-1.346-5.273c-11.278-6.695-27.41-8.91-40.927-7.831Zm28.004 38.17a2.563 2.563 0 0 0 3.528-.85 2.564 2.564 0 0 0-.85-3.528c-10.845-6.627-24.289-8.17-39.96-4.589a2.565 2.565 0 0 0 1.141 5.002c14.32-3.272 26.481-1.936 36.141 3.965Zm4.151-10.996a3.207 3.207 0 0 0 4.412-1.058 3.207 3.207 0 0 0-1.056-4.41c-12.7-7.804-31.275-10-46.217-5.467a3.212 3.212 0 0 0-2.14 4.001 3.212 3.212 0 0 0 4.004 2.137c13.08-3.97 29.938-2.002 40.998 4.797Z"
      fill="#1ED760"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 18c0 9.941-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0s18 8.059 18 18Zm-27.515-.225a3.214 3.214 0 0 1 3.214-3.214h2.99V11.7a3.214 3.214 0 0 1 6.428 0v2.86h2.957a3.214 3.214 0 0 1 0 6.43h-2.957v3.085a3.214 3.214 0 0 1-6.428 0V20.99h-2.99a3.214 3.214 0 0 1-3.214-3.215Z"
      fill="#fff"
    />
  </svg>
);

const MemoSpotifyAdd = memo(SpotifyAdd);
export default MemoSpotifyAdd;
